import React from "react";
import { Delete } from "@mui/icons-material";
import { Button, ButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useCmrAuth } from "state/CMRAuth";
import { openNotification } from "state/slices/NotificationSlice";
import { useTypedDispatch } from "hooks/store";

type Props = {
    sceneKey: string;
    isGlobal?: boolean;
    onDeleted: () => void;
};

const DeleteButton = styled(Button)<ButtonProps>(() => ({
    fontSize: 18,
    fontWeight: "bold",
    color: "#FFFFFF",
    position: "absolute",
    borderRadius: "0px",
    borderBottomRightRadius: "12px",
    backgroundColor: "#c80303",
    zIndex: 100,
    top: 0,
    left: 0,
    lineHeight: 1.5,
    "&:hover": {
        backgroundColor: "#e20f0f",
    },
    "&:active": {
        backgroundColor: "#f32727",
    },
}));

const DeleteScene: React.FC<Props> = ({ sceneKey, isGlobal, onDeleted }) => {
    const cmrAuth = useCmrAuth();
    const dispatch = useTypedDispatch();

    const user = cmrAuth.user;
    const groups = user?.groups ?? [];

    //@todo update this when we know the permissions
    const isAdmin = groups.includes("partner.admin.gbr");

    const canDelete = !isGlobal || isAdmin;

    if (!canDelete) {
        return null;
    }

    const handleDelete = async (event: React.MouseEvent<HTMLButtonElement>): Promise<void> => {
        event.stopPropagation();

        const token = await cmrAuth.getAccessToken();

        try {
            const url = isGlobal
                ? `${process.env.REACT_APP_API_URL}/api/global/${sceneKey}`
                : `${process.env.REACT_APP_API_URL}/api/scene/${sceneKey}`;

            const res = await fetch(url, {
                method: "DELETE",

                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (!res.ok) {
                dispatch(
                    openNotification({
                        isNotificationOpen: true,
                        type: "error",
                        text: "There was a problem deleting the setup.",
                    })
                );
                return;
            }

            dispatch(
                openNotification({
                    isNotificationOpen: true,
                    type: "success",
                    text: "Setup was deleted successfully.",
                })
            );

            onDeleted();
        } catch (err) {
            dispatch(
                openNotification({
                    isNotificationOpen: true,
                    type: "error",
                    text: "There was a problem deleting the setup.",
                })
            );
        }
    };

    return (
        <DeleteButton onClick={handleDelete}>
            <Delete />
        </DeleteButton>
    );
};

export default DeleteScene;
